import * as ActionTypes from '../constants/ActionTypes'
import {getAppMode} from "../selectors/Mode";


// **************************************************************************************************************
export const appStateReducer = (state = {
    isInitialized: false,
    isFetchingFormData: false,
    orderComplete: false,
    pinCodeVerified: false,
    mode: getAppMode()
}, action) => {

    switch (action.type) {

        case ActionTypes.APP_INITIALIZED:
            return Object.assign({}, state, {isInitialized: true})


        case ActionTypes.CART_PINCODE_VERIFY_REQUEST:
            return Object.assign({}, state, {pinCodeVerified: false})


        case ActionTypes.CART_PINCODE_VERIFY_SUCCESS:
            return Object.assign({}, state, {pinCodeVerified: true})

        case ActionTypes.CART_PUT_FORM_DATA_REQUEST:

            return Object.assign({}, state, {isFetchingFormData: true})

        case ActionTypes.CART_PUT_FORM_DATA_SUCCESS:
        case ActionTypes.CART_PUT_FORM_DATA_FAILURE:

            return Object.assign({}, state, {isFetchingFormData: false})

        case ActionTypes.CART_CHECKOUT_REQUEST:
        case ActionTypes.CART_CHECKOUT_SUCCESS:

            return Object.assign({}, state, {orderComplete: true})

        case ActionTypes.CLIENTDATA_SUCCESS:

            return Object.assign({}, state, {isAuthenticatedUser: true})

        default:

            return state

    }

}



/** WEBPACK FOOTER **
 ** ./src/reducers/AppState.js
 **/